import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
`;

export const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

export const Title = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const InforTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
`;

export const Image = styled.img`
    width: 190px;
`;

export const H3 = styled.h3`
`;

export const TextP = styled.p`
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_600};
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const InforTitleErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    display: flex;
    justify-content: center;
    font-size: 14px;
`;

export const Forms = styled.form`
    display: flex;
    flex-direction: column;
    gap: 36px;
`;

export const InputForms = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_600};
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const InputUnstyled = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    width: 100%;
`;

export const ButtonOpenPassword = styled.button`
    display: flex;
    background-color: transparent;
    svg{
        width: 48px;
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const ContainerPassword = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ForgotPassword = styled.p`
    text-align: end;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_600};
    span{
        margin-left: 3px;
        color: ${(props) => props.theme.colors.primary};
        text-decoration: underline;
    }
`;